export class ErrorImmutable {
    error: string = "";
    errors: string[] = [];
    incorrectData: string = "Please correct the data requested above in order to save.";

    constructor(error: string, fields: string[]) {
        this.error = error;
        this.errors = fields;
        Object.freeze(this);
    }
    showError(): boolean {
        return (this.errors.length > 0 || this.error.length > 0);
    }
    fieldRequired() {
        return { 'required': true };
    }
    passwordsMustMatch() {
        return { 'error': 'passwords must match' };
    }
    isWrong(fieldName: string): boolean {
        return this.errors.includes(fieldName);
    }
    clear(): ErrorImmutable {
        return new ErrorImmutable("", []);
    }
    addToErrors(fieldName: string): ErrorImmutable {
        if (this.errors.includes(fieldName)) {
            return this;
        }
        return new ErrorImmutable(this.error, [...this.errors, fieldName]);
    }
    removeFromErrors(fieldName: string): ErrorImmutable {
        if (!this.errors.includes(fieldName)) {
            return this;
        }
        let errors = [...this.errors];
        errors.splice(errors.indexOf(fieldName), 1);
        let errorText = this.error;
        if (errors.length == 0) {
            errorText = "";
        }
        return new ErrorImmutable(errorText, errors);
    }
    setError(error: string): ErrorImmutable {
        return new ErrorImmutable(error, [...this.errors]);
    }
}
